<template>
  <div id="app">
    <MainPage/>
  </div>
</template>

<script>
import MainPage from './components/MainPage.vue'
import Store from './utils/store.js'

export default {
    name: 'App',
    components: {
        MainPage
    },
    created: function() {
        Store.url = "https://aide-covid-back.grandlyon.com/";
        Store.project = "_";
        Store.table = "initiatives";
        Store.table_news = "actualites";
    }
}
</script>

<style>

@font-face {
 font-family: "Raleway";
 src: url("./static/fonts/Raleway-Medium.ttf");
}

:root {
  --light-red: #FE4445;
  --medium-red: #EB1923;
  --MET-red: #e51c14;
  --dark-blue : #28277E;
  --dark-grey : #333333;
  --medium-dark-grey: #828282;
  --medium-grey : #4F4F4F;
  --medium-light-grey : #E0E0E0;
  --light-grey : #C4C4C4;
  --very-light-grey: #EDEDED;
  --almost-white: #FBFBFB;
  font-family: Raleway;
}

a:hover, button:hover {
  cursor:pointer;
}

body {
  margin : 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

h1 {
  font-weight: 900;
  font-size: 1.5vw;
  color : black;
  margin: 1% 0;
}

h2 {
  font-weight: bold;
  color: white;
  font-size: 1.5vw;
}

h3 {
  font-weight: bold;
  font-size: 1.5vw;
  margin: 0;
}

header{
  padding-top: 10px;
  display:flex;
}

.icon {
  height: 50px;
}

.bouton:link {
  background-color: var(--medium-red);
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 20px;
  padding: 5px 0 5px 0;
  font-weight: bold;
}

.bouton:visited{
  color: white;
}

@media (max-width: 600px) {
  h1{
    font-size: 4.5vw;
    margin: 1%;
  }

  h2{
    font-size: 4vw;
    margin-bottom: 2%;
    margin-top: 0;
  }
}
</style>
